// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const updateTagApi = (tagId, tag) => api().post(`/tags/${tagId}`, tag);

export default updateTagApi;
